var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoweredUsbHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 61,
    viewBox: "0 0 79 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 50.1475H63.7392V55.7456C63.7392 56.8502 62.8438 57.7456 61.7392 57.7456H17.1111C16.0065 57.7456 15.1111 56.8502 15.1111 55.7456V50.1475Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_31901)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6935 48.7262C75.9869 48.74 76.2135 48.9891 76.1997 49.2825C76.1625 50.0717 75.7735 50.7667 75.1647 51.3651C74.5601 51.9594 73.7152 54.0033 72.6949 54.4701C70.6535 55.404 67.7968 56.1578 64.4248 56.7502C57.6714 57.9365 48.7224 58.4964 39.7742 58.4889C30.8248 58.4815 21.847 57.9065 15.0335 56.8129C11.6307 56.2668 8.74154 55.5873 6.65975 54.773C5.62032 54.3663 4.75463 52.396 4.12335 51.8922C3.49542 51.391 3.04343 50.7908 2.95797 50.0808C2.92286 49.7892 3.13082 49.5243 3.42246 49.4892C3.7141 49.4541 3.97898 49.6621 4.01408 49.9537C4.05272 50.2747 4.26959 50.6479 4.78694 51.0608C5.30094 51.4711 6.05695 51.8753 7.04728 52.2627C9.025 53.0364 11.8276 53.7014 15.202 54.243C21.9429 55.3249 30.8613 55.8981 39.7751 55.9056C48.69 55.913 57.5713 55.3545 64.2407 54.1829C67.5801 53.5962 70.333 52.8612 72.2524 51.9831C73.2125 51.5439 73.9359 51.0814 74.419 50.6065C74.8979 50.1357 75.1161 49.679 75.1372 49.2324C75.151 48.939 75.4001 48.7123 75.6935 48.7262Z",
    fill: "#D14FFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13965 23.4238C3.49253 29.7756 75.5308 28.9817 75.8396 23.4238V45.9114C75.8396 50.6474 72.2083 54.6047 67.4851 54.9529C46.8249 56.4759 32.4929 56.4799 11.5025 54.9465C6.77569 54.6012 3.13965 50.6425 3.13965 45.9031V23.4238Z",
    fill: "#282524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78683 5.29828L3.48412 21.1442C2.66326 23.7289 3.12959 26.6325 6.47765 27.557C21.0505 31.5812 59.876 31.1269 72.5793 27.4264C74.8507 26.7647 76.3266 24.1759 75.6667 21.904L70.1562 5.47862C69.2134 2.23277 66.2397 0 62.8597 0H16.0285C12.7182 0 9.78883 2.14323 8.78683 5.29828Z",
    fill: "url(#paint0_linear_2_31901)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6935 22.8922C75.9869 22.906 76.2135 23.1551 76.1997 23.4485C76.1625 24.2377 75.7735 24.9327 75.1647 25.5311C74.5601 26.1254 73.7152 26.6497 72.6949 27.1165C70.6535 28.0504 67.7968 28.8042 64.4248 29.3966C57.6714 30.5829 48.7224 31.1428 39.7742 31.1353C30.8248 31.1279 21.847 30.5529 15.0335 29.4593C11.6307 28.9132 8.74154 28.2337 6.65975 27.4193C5.62032 27.0127 4.75463 26.5621 4.12335 26.0582C3.49542 25.557 3.04343 24.9568 2.95797 24.2469C2.92286 23.9552 3.13082 23.6903 3.42246 23.6552C3.7141 23.6201 3.97898 23.8281 4.01408 24.1197C4.05272 24.4407 4.26959 24.8139 4.78694 25.2268C5.30094 25.6371 6.05695 26.0413 7.04728 26.4287C9.025 27.2024 11.8276 27.8674 15.202 28.409C21.9429 29.4909 30.8613 30.0642 39.7751 30.0716C48.69 30.079 57.5713 29.5205 64.2407 28.3489C67.5801 27.7623 70.333 27.0273 72.2524 26.1492C73.2125 25.7099 73.9359 25.2474 74.419 24.7725C74.8979 24.3017 75.1161 23.845 75.1372 23.3984C75.151 23.105 75.4001 22.8784 75.6935 22.8922Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2625 24.9434C15.2625 24.7336 15.4325 24.5635 15.6424 24.5635H19.4414C19.6512 24.5635 19.8213 24.7336 19.8213 24.9434C19.8213 25.1532 19.6512 25.3233 19.4414 25.3233H15.6424C15.4325 25.3233 15.2625 25.1532 15.2625 24.9434Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8999 24.9434C25.8999 24.7336 26.07 24.5635 26.2798 24.5635H30.0789C30.2887 24.5635 30.4588 24.7336 30.4588 24.9434C30.4588 25.1532 30.2887 25.3233 30.0789 25.3233H26.2798C26.07 25.3233 25.8999 25.1532 25.8999 24.9434Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5374 24.9434C36.5374 24.7336 36.7074 24.5635 36.9173 24.5635H40.7163C40.9262 24.5635 41.0962 24.7336 41.0962 24.9434C41.0962 25.1532 40.9262 25.3233 40.7163 25.3233H36.9173C36.7074 25.3233 36.5374 25.1532 36.5374 24.9434Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1748 24.9434C47.1748 24.7336 47.3449 24.5635 47.5547 24.5635H51.3538C51.5636 24.5635 51.7337 24.7336 51.7337 24.9434C51.7337 25.1532 51.5636 25.3233 51.3538 25.3233H47.5547C47.3449 25.3233 47.1748 25.1532 47.1748 24.9434Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.812 24.9434C57.812 24.7336 57.9821 24.5635 58.1919 24.5635H61.991C62.2008 24.5635 62.3709 24.7336 62.3709 24.9434C62.3709 25.1532 62.2008 25.3233 61.991 25.3233H58.1919C57.9821 25.3233 57.812 25.1532 57.812 24.9434Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_31901",
    x: 0.954102,
    y: 46.7256,
    width: 77.2461,
    height: 13.7637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2_31901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31901",
    x1: 39.4785,
    y1: 0,
    x2: 39.4785,
    y2: 30.3926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565251"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredUsbHub);
export default __webpack_public_path__ + "static/media/PoweredUSBHub.6702341d10c52b8fe8ba20593c16dba0.svg";
export { ForwardRef as ReactComponent };